import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/takeUntil';
import { OffboardingCase, OffboardingHistory, OffboardingMutation, OffboardingStage } from '../../models/offboarding.model';
import { OffboardingService } from '../../services/offboarding.service';
import { ASSET } from '../common/employee-assets/asset.constants';
import { assetErrorKey, assetOperationId, workflowTrackBy } from '../common/employee-assets/asset.helpers';
import { OFFBOARDING as O } from './offboarding.constants';

@Component({selector: 'app-offboarding-approval', templateUrl: './offboarding-approval.component.html',
  styleUrls: ['./offboarding-sequential.component.css', './offboarding-workspace-content.css']})
export class OffboardingApprovalComponent implements OnChanges, OnDestroy {
  @Input() item: OffboardingCase;
  @Input() stage: OffboardingStage;
  @Input() events: OffboardingHistory[] = [];
  @Input() disabled = false;
  @Output() saved = new EventEmitter<OffboardingCase>();
  @Output() refresh = new EventEmitter<void>();
  trackBy = workflowTrackBy;
  constants = O;
  assetConstants = ASSET;
  actions: string[] = [];
  history: OffboardingHistory[] = [];
  reason = ASSET.empty;
  terminationDate = ASSET.empty;
  canReturnToCeo = false;
  busy = false;
  errorKey = ASSET.empty;
  private pending: OffboardingMutation;
  private submittedContent = ASSET.empty;
  private destroyed = new Subject<void>();
  constructor(private api: OffboardingService) {}
  ngOnChanges(): void {
    this.actions = (this.stage.allowedActions || []).filter(value => APPROVAL.actions.indexOf(value) >= ASSET.zero);
    this.canReturnToCeo = this.actions.indexOf(O.returnToCeo) >= ASSET.zero;
    this.history = this.events.filter(event => APPROVAL.history.indexOf(event.action) >= ASSET.zero);
  }
  ngOnDestroy(): void { this.destroyed.next(); this.destroyed.complete(); }
  act(action: string): void {
    if (this.busy || this.disabled || this.actions.indexOf(action) < ASSET.zero || this.errorKey === ASSET.conflictKey || this.errorKey === ASSET.deniedKey) { return; }
    if (action !== O.ceoApprove && !this.reason.trim()) { this.errorKey = APPROVAL.reasonRequired; return; }
    const date = action === O.returnToCeo ? this.terminationDate : ASSET.empty;
    const content = JSON.stringify([action, this.reason, date]);
    if (!this.pending || content !== this.submittedContent) {
      this.pending = {operationId: assetOperationId(), expectedVersion: this.item.version, action: action,
        reason: this.reason.trim(), terminationDate: date || undefined};
    }
    this.submittedContent = content; this.busy = true; this.errorKey = ASSET.empty;
    this.api.act(this.item.id, this.pending).takeUntil(this.destroyed).subscribe(result => {
      this.busy = false; this.pending = null; this.reason = ASSET.empty; this.terminationDate = ASSET.empty; this.saved.emit(result);
    }, error => { this.busy = false; this.errorKey = assetErrorKey(error, true); });
  }
  checkCurrent(): void { this.pending = null; this.errorKey = ASSET.empty; this.refresh.emit(); }
}
const APPROVAL = {actions: [O.ceoApprove, O.reject, O.returnToCeo, O.cancel],
  history: [O.ceoApprove, O.reject, O.returnToCeo, O.cancel, O.proposeDates, O.hrDates, O.ceoDates, O.rejectDates],
  reasonRequired: 'offboarding.approval.reasonRequired'};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-approval.component.ts